import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    logs: [],
};

const logsSlice = createSlice({
    name: 'loudnessLogs',
    initialState,
    reducers: {
        addLogs(state, action) {
            if (Array.isArray(action.payload) && action.payload.length > 0) {
                state.logs = [...action.payload, ...state.logs];
            }
        },
        updateOrAddLogs(state, action) {
            if (Array.isArray(action.payload) && action.payload.length > 0) {
                action.payload.forEach(newLog => {
                    // Skip separator logs
                    if (newLog.status === 'separator') {
                        return;
                    }

                    // Store summary logs (e.g. "No audio files found")
                    if (newLog.status === 'summary') {
                        state.logs = [newLog, ...state.logs];
                        return;
                    }

                    if (newLog.filePath) {
                        const existingIndex = state.logs.findIndex(log => log.filePath === newLog.filePath);
                        // A log carrying oldFilePath is a produced file
                        // (rename / [-x LUFS] copy) — it REPLACES the
                        // original's row at its position, so a fix updates
                        // rows in place instead of prepending duplicates
                        // (same rule as the compatibility logsSlice).
                        const oldIndex = (newLog.oldFilePath && newLog.oldFilePath !== newLog.filePath)
                            ? state.logs.findIndex(log => log.filePath === newLog.oldFilePath)
                            : -1;
                        if (existingIndex !== -1) {
                            // Update existing log
                            state.logs[existingIndex] = newLog;
                            // The original's row is superseded — drop it so the
                            // same track never shows twice.
                            if (oldIndex !== -1 && oldIndex !== existingIndex) {
                                state.logs = state.logs.filter((_, i) => i !== oldIndex);
                            }
                        } else if (oldIndex !== -1) {
                            state.logs[oldIndex] = newLog;
                        } else {
                            // Add new log at the beginning
                            state.logs = [newLog, ...state.logs];
                        }
                    } else {
                        // No filePath, just add it
                        state.logs = [newLog, ...state.logs];
                    }
                });
            }
        },
        clearLogs(state) {
            state.logs = [];
        },
        setLogs(state, action) {
            state.logs = action.payload;
        },
        // Drop rows still waiting on a result. Pre-populated "pending" rows
        // that the run never reported on (skipped by the walker, cancelled,
        // or extension-set mismatch) must not linger as forever-queued.
        clearPendingLogs(state) {
            state.logs = state.logs.filter((l) => !l || typeof l !== 'object' || l.status !== 'pending');
        },
        addLogsLineBreak(state) {
            state.logs = ['\n', ...state.logs];
        },
        // Remove ONE track's rows from the list (the row menu's "Remove from list").
        removeLogsForFile(state, action) {
            state.logs = state.logs.filter((l) => !l || l.filePath !== action.payload);
        }
    },
});

export const { addLogs, updateOrAddLogs, clearLogs, setLogs, clearPendingLogs, addLogsLineBreak, removeLogsForFile } = logsSlice.actions;
export default logsSlice.reducer;
